import React from 'react'
import '../App.css'

function Tokenomics() {
  return (
    <div className='token-container'>
        <h1>Tokenomics</h1>
        <p>Token Supply:</p>
        <p>21 Million $BITCOIN | BITCOiN</p>
    </div>
  )
}

export default Tokenomics